import React from "react";
import SliderImagesContainer from "../sliderImagesContainer/SliderImagesContainer";

// Modern WithRightBox Component
const WithRightBox = ({ data }) => {
  const { boxHeader, boxHeader2, boxPara, images } = data;

  return (
    <div className="w-full max-w-[87rem] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative">
        {/* Image Container */}
        <div className="w-full h-64 sm:h-80 md:h-96 lg:h-[50rem] rounded-xl overflow-hidden shadow-lg">
          <SliderImagesContainer images={images} />
        </div>

        {/* Desktop Text Box - Overlaid on larger screens */}
        <div className="hidden lg:block absolute top-0 right-0 w-1/3 max-w-md">
          <div className="bg-white/95 backdrop-blur-md rounded-xl shadow-2xl p-6 xl:p-8 border border-white/20">
            <h2 className="text-gray-900 text-2xl xl:text-3xl font-bold leading-tight mb-2">
              {boxHeader}
            </h2>
            <h2 className="mb-4 text-[#10c9c0] text-lg xl:text-xl font-medium leading-relaxed">
              {boxHeader2}
            </h2>
            <p className="text-justify text-[#949995] text-base font-light leading-6">
              {boxPara}
            </p>
          </div>
        </div>

        {/* Mobile/Tablet Text Box - Below image */}
        <div className="block lg:hidden mt-6">
          <div className="bg-white rounded-xl p-6 border border-gray-100">
            <h2 className="text-gray-900 text-xl sm:text-2xl font-bold leading-tight mb-3">
              {boxHeader}
            </h2>
            <h2 className="mb-4 text-[#10c9c0] text-md sm:text-lg font-medium leading-relaxed">
              {boxHeader2}
            </h2>
            <p className="text-justify text-[#949995] text-base font-light leading-6">
              {boxPara}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithRightBox;